import { AttributeList, AttributeDetails } from '@customTypes';
import { EMPTY_STRING, NO_VALUE_RESPONSE, SCALED_SLIDER_DEFAULT_VALUE } from '@constants';

import { roundToHalf } from '.';

export const transformAttributeList = (response: AttributeList['Response']): AttributeDetails[] =>
  response.payload?.length
    ? response.payload?.map((el) => {
        const { importance, included, note, description } = el;

        return {
          ...el,
          included: importance === null && importance === NO_VALUE_RESPONSE ? false : included,
          importance: importance ? roundToHalf(importance) : SCALED_SLIDER_DEFAULT_VALUE,
          note: note ?? EMPTY_STRING,
          description: description ?? EMPTY_STRING,
        };
      })
    : [];
